export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-mixed-white/71b0b5e54afee7be0131b5e363625273.png";